<template>
  <div class="DarkWhite pa-4 ">
      <h2 class="subheading green--text">Item Utility</h2>
      <v-card class="mt-4">
      <PSUitemutility/>
  </v-card>
  </div>
</template>

<script>
import PSUitemutility from '../components/Utils/PSUitemutility.vue'
  export default {
    components: {
      PSUitemutility
    },
    data: () => ({
    }),
  }
</script>

<style scoped>
</style>